<template>
  <div>
    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th
                  class="school-col"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  <button class="btn p-0" @click="setSortBy('school')">
                    School
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'school'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'school_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="subject-col">
                  <button class="btn p-0" @click="setSortBy('subject')">
                    Class Subject
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'subject'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'subject_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="subjectlevel-col">
                  <button class="btn p-0" @click="setSortBy('subjectLevel')">
                    Subject Level
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'subjectLevel'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'subjectLevel_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="duration-col">
                  <button class="btn p-0" @click="setSortBy('duration')">
                    Duration
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'duration'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'duration_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="frequency-col">
                  <button class="btn p-0" @click="setSortBy('frequency')">
                    Frequency
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'frequency'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'frequency_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="date-col">
                  <button class="btn p-0" @click="setSortBy('date')">
                    Commencement Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'date'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'date_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="time-col">
                  <button class="btn p-0" @click="setSortBy('time')">
                    Class Time
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'time'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'time_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="location-col">
                  <button class="btn p-0" @click="setSortBy('location')">
                    Location
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'location'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'location_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="capacity-col">
                  <button class="btn p-0" @click="setSortBy('capacity')">
                    Maximum Capacity
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'capacity'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'capacity_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in classes" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td
                  class="school-col"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  {{ item.SchoolName }}
                </td>
                <td class="subject-col">{{ item.SubjectName }}</td>
                <td class="subjectlevel-col">{{ item.SubjectLevelName }}</td>
                <td class="duration-col">{{ item.Duration }}</td>
                <td class="frequency-col">{{ item.Frequency }}</td>
                <td class="date-col">{{ item.CommencementDateDisplay }}</td>
                <td class="time-col">{{ item.ClassTime }}</td>
                <td class="location-col">{{ item.Location }}</td>
                <td class="capacity-col">{{ item.Capacity }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name: classShowRouter,
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-file-alt mr-2"></i>View
                      </button>
                      <button
                        v-if="!isInstructor && !isStudent"
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminClassEdit'
                                : 'schoolAdminClassEdit',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button
                        v-if="!isInstructor && !isStudent"
                        class="dropdown-item"
                        @click="deleteClass(item.Id)"
                      >
                        <i class="fa fa-trash-o mr-2"></i>Delete
                      </button>
                      <button
                        class="dropdown-item"
                        @click="addClassBooking(item.Id)"
                      >
                        <i class="fa fa-circle-plus mr-1"></i>
                        Add Class Booking
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="classes && !classes.length">
                <td colspan="11" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="classes && classes.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          classes.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config";
export default {
  props: [
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "frequency",
    "locationId",
    "availability",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "instructorName",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      noRecordText: config.NO_RECORD_TEXT,
      classes: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
    isStudent() {
      return (
        this.tokenObj.UserType == this.userTypeStudent &&
        this.$route.path.includes("/student/")
      );
    },
    classShowRouter() {
      let router = "";
      if (this.isInstructor) {
        router = "instructorMyAssignedClassShow";
      } else if (this.isStudent) {
        router = "studentClassAvailabilityShow";
      } else {
        router =
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? "mainAdminClassShow"
            : "schoolAdminClassShow";
      }
      return router;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getClassList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    deleteClass(classId) {
      let param = {
        Token: this.tokenObj.Token,
        Id: classId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the class?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.class
            .deleteClass(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getClassList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getClassList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        Frequency: this.frequency,
        LocationId: this.locationId,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        Availability: this.availability,
        InstructorId: this.isInstructor ? this.tokenObj.Id : "",
        InstructorName: this.instructorName,
      };
      this.$store.state.isLoading = true;
      API.class
        .getClassList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classes = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    addClassBooking(classId) {
      this.$store.state.class.classId = classId;
      if (this.isInstructor) {
        this.$router.push({ name: "instructorClassBookingAdd" });
      } else if (this.isStudent) {
        this.$router.push({ name: "studentClassBookingForm" });
      } else {
        this.$router.push({
          name:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? "mainAdminClassBookingAdd"
              : "schoolAdminClassBookingAdd",
        });
      }
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getClassList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getClassList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getClassList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getClassList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getClassList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "school":
          if (this.paging.SortBy === "school") {
            this.paging.SortBy = "school_desc";
          } else if (this.paging.SortBy === "school_desc") {
            this.paging.SortBy = "school";
          } else {
            this.paging.SortBy = "school";
          }
          break;
        case "subject":
          if (this.paging.SortBy === "subject") {
            this.paging.SortBy = "subject_desc";
          } else if (this.paging.SortBy === "subject_desc") {
            this.paging.SortBy = "subject";
          } else {
            this.paging.SortBy = "subject";
          }
          break;
        case "subjectLevel":
          if (this.paging.SortBy === "subjectLevel") {
            this.paging.SortBy = "subjectLevel_desc";
          } else if (this.paging.SortBy === "subjectLevel_desc") {
            this.paging.SortBy = "subjectLevel";
          } else {
            this.paging.SortBy = "subjectLevel";
          }
          break;
        case "duration":
          if (this.paging.SortBy === "duration") {
            this.paging.SortBy = "duration_desc";
          } else if (this.paging.SortBy === "duration_desc") {
            this.paging.SortBy = "duration";
          } else {
            this.paging.SortBy = "duration";
          }
          break;
        case "frequency":
          if (this.paging.SortBy === "frequency") {
            this.paging.SortBy = "frequency_desc";
          } else if (this.paging.SortBy === "frequency_desc") {
            this.paging.SortBy = "frequency";
          } else {
            this.paging.SortBy = "frequency";
          }
          break;
        case "date":
          if (this.paging.SortBy === "date") {
            this.paging.SortBy = "date_desc";
          } else if (this.paging.SortBy === "date_desc") {
            this.paging.SortBy = "date";
          } else {
            this.paging.SortBy = "date";
          }
          break;
        case "time":
          if (this.paging.SortBy === "time") {
            this.paging.SortBy = "time_desc";
          } else if (this.paging.SortBy === "time_desc") {
            this.paging.SortBy = "time";
          } else {
            this.paging.SortBy = "time";
          }
          break;
        case "location":
          if (this.paging.SortBy === "location") {
            this.paging.SortBy = "location_desc";
          } else if (this.paging.SortBy === "location_desc") {
            this.paging.SortBy = "location";
          } else {
            this.paging.SortBy = "location";
          }
          break;
        case "capacity":
          if (this.paging.SortBy === "capacity") {
            this.paging.SortBy = "capacity_desc";
          } else if (this.paging.SortBy === "capacity_desc") {
            this.paging.SortBy = "capacity";
          } else {
            this.paging.SortBy = "capacity";
          }
          break;
      }
      this.getClassList();
    },
  },
  created() {
    this.getClassList();
  },
};
</script>

<style scoped>
table {
  min-height: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassListTableFormat.vue